<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import NextButton from 'dashboard/components-next/button/Button.vue';

// 报表数据 API 说明块(定制 2026-08-18):
// 用个人 Access Token 调用留电来源报表, 数据权限与后台报表一致——
// 客服只返回自己归属的数据; 管理员/前台/网络部主管返回全部。
const emit = defineEmits(['onCopy']);

const route = useRoute();
const apiUrl = computed(() => {
  const { accountId } = route.params;
  return `${window.location.origin}/api/v1/accounts/${accountId}/contacts/lead_source_report`;
});

const curlExample = computed(
  () =>
    `curl -H "api_access_token: 上方Access Token" "${apiUrl.value}?since=2026-08-18&until=2026-08-18"`
);

const params = [
  { name: 'since / until', desc: '留电日期范围, 北京时区 YYYY-MM-DD' },
  { name: 'sources[]', desc: '来源多选(百度/必应/直接访问…), 空 = 全部' },
  { name: 'owners[]', desc: '归属者多选, 仅管理员/前台/网络部主管有效; 客服强制只返回自己' },
];

const onClick = value => emit('onCopy', value);
</script>

<template>
  <div class="space-y-4">
    <div>
      <p class="mb-1 text-xs font-medium text-n-slate-9">接口地址</p>
      <div class="flex items-center gap-2">
        <code
          class="flex-1 overflow-x-auto rounded-lg bg-n-slate-3 px-3 py-2 text-xs text-n-slate-12"
        >
          GET {{ apiUrl }}
        </code>
        <NextButton
          label="复制"
          slate
          outline
          type="button"
          icon="i-lucide-copy"
          class="rounded-xl"
          @click="onClick(apiUrl)"
        />
      </div>
    </div>
    <div>
      <p class="mb-1 text-xs font-medium text-n-slate-9">请求头</p>
      <code
        class="block overflow-x-auto rounded-lg bg-n-slate-3 px-3 py-2 text-xs text-n-slate-12"
      >
        api_access_token: &lt;上方 Access Token 的密钥&gt;
      </code>
    </div>
    <div>
      <p class="mb-1 text-xs font-medium text-n-slate-9">参数</p>
      <ul class="space-y-1 text-xs text-n-slate-11">
        <li v-for="p in params" :key="p.name">
          <span class="font-medium text-n-slate-12">{{ p.name }}</span>
          — {{ p.desc }}
        </li>
      </ul>
    </div>
    <div>
      <p class="mb-1 text-xs font-medium text-n-slate-9">调用示例</p>
      <div class="flex items-center gap-2">
        <pre
          class="flex-1 overflow-x-auto rounded-lg bg-n-slate-3 px-3 py-2 text-xs text-n-slate-12"
          >{{ curlExample }}</pre
        >
        <NextButton
          label="复制"
          slate
          outline
          type="button"
          icon="i-lucide-copy"
          class="rounded-xl"
          @click="onClick(curlExample)"
        />
      </div>
    </div>
  </div>
</template>
